module.exports = __webpack_public_path__ + "img/staticon.4389129c.svg";